import React from "react";
import PublicInspectionMessage from "./PublicInspectionMessage";

export default function PublicInspectionNeedsSchedulingMessage({ inspectionId }: { inspectionId: string | number }) {
  return <PublicInspectionMessage title={"Your inspection needs to be scheduled"} inspectionId={inspectionId} />;
}
